import React from "react";
import { useUser } from "@/app/providers";
import { string, object } from "prop-types";
import { useUpdateProfile } from "@/hooks";
import { CustomerDropdown } from "@/components";
import type { SxProps, Theme } from "@mui/material/styles";

type CustomerDropdownAutoSaveProps = {
  componentLabel?: string;
  sx?: SxProps<Theme>;
};

type CustomerChangeEvent = {
  label?: string;
  value?: string;
};

/**
 * Customer dropdown component
 * @param {object} props props
 * @returns {React.JSX.Element} React Component
 * @class
 */
export const CustomerDropdownAutoSave = (
  props: CustomerDropdownAutoSaveProps,
) => {
  const { updateProfile } = useUpdateProfile();
  const { user, setUser } = useUser();
  const { currentTeamId, currentCustomerKey } = user || {};

  const handleChange = (event: CustomerChangeEvent) => {
    const customerKey = (event as any).key || event.value;
    if (
      event.value &&
      event.value !== "" &&
      (event.value !== currentTeamId || customerKey !== currentCustomerKey)
    ) {
      setUser((prev: any) => ({
        ...prev,
        currentCustomerKey: customerKey,
        currentTeam: event.label,
        currentTeamId: event.value,
      }));
      updateProfile({
        currentCustomerKey: customerKey,
      });
    }
  };

  return (
    <CustomerDropdown
      defaultValue={currentCustomerKey || currentTeamId}
      required
      onChange={handleChange}
      componentLabel={props.componentLabel}
      currentTeamId={user?.currentTeamId}
      currentTenantId={user?.currentTenantId}
      sx={{
        ...props.sx,
      }}
    />
  );
};

CustomerDropdownAutoSave.propTypes = {
  componentLabel: string,
  sx: object,
};
